// src/experiments/format.js

// The analytics form of a set of assignments: `flow_v2:b|hero_copy:a`, keys
// sorted so the same assignments always produce the same string. Empty when
// there is nothing to say, so callers can leave payloads untouched.
export function formatAssignments(assignments) {
  if (!assignments || typeof assignments !== 'object') return '';
  return Object.keys(assignments)
    .sort()
    .map((key) => `${key}:${assignments[key]}`)
    .join('|');
}
